import React, { useRef } from 'react';
import { Tag } from 'antd';
import HtmlEditor from './HtmlEditor/HtmlEditor';

const HtmlEditorTags = ({ onChange, value, height, keys = [], ...rest }) => {
  const ref = useRef(null);

  const handleClickTag = (key) => {
    ref.current.insert(key);
  };

  return (
    <div>
      <HtmlEditor
        ref={ref}
        height={height}
        onChange={onChange}
        value={value}
        {...rest}
      />
      <div className="gx-mt-2">
        {keys.map(({ key, color, title }) => (
          <Tag
            className="gx-pointer"
            color={color}
            onClick={() => handleClickTag(key)}
          >
            {title}
          </Tag>
        ))}
      </div>
    </div>
  );
};

export default HtmlEditorTags;
